export default "__VITE_ASSET__BLOaQOUL__"